import { render, staticRenderFns } from "./mock.vue?vue&type=template&id=88b4d7a2&"
import script from "./mock.js?vue&type=script&lang=js&"
export * from "./mock.js?vue&type=script&lang=js&"
import style0 from "./mock.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports